<template>
    <section class="section">
        <div class="section__header">
            <h3 class="section__title">
                {{ getTranslation('eventCalendar') }}
            </h3>
            <div class="section__controls">
                <div class="event-dispatch-stats col-6">
                    <div v-if="application.notDispatchedCandidateCount > 0" class="event-dispatch-item">
                        <div class="event-dispatch-item--num">{{ application.notDispatchedCandidateCount }}</div>
                        {{ getTranslation('notDispatchedCandidates') }}
                    </div>
                </div>
                <div v-if="!calendarOptions.eventCreate" class="section__controls-group">
                    <a href="javascript:void(0)" v-if="calendarOptions.tableView" class="btn  btn--info-outline btn--sm" @click="toggleCalendarView">{{ getTranslation('eventTableView') }}</a>
                    <button v-if="application.status==='NEW' && calendarOptions.tableView && hasPermission('api.application.profile.editEvent')" class="btn btn--main-outline btn--sm" @click="()=>{ this.$router.push( { name: 'api.application.profile.editEvent', params: { id: this.application.id } } );}">
                        {{getTranslation('editingEvents')}}
                    </button>
                    <button v-if="subjectId && hasPermission('api.application.profile.createEvent') && subjectType!=='office'" class="btn btn--main btn--sm" @click="()=>{ this.$router.push( { name: 'api.application.profile.createEvent', params: { id: this.application.id } } );}">+ {{getTranslation('addEvent')}}
                    </button>
                </div>
                <div v-if="calendarOptions.eventCreate && hasPermission('api.application.profile.createEvent')" class="section__controls-group" id="draggable-area">
                    <span title="Передвигать" class="fc-event font-weight-bold">
                        <img src="@/assets/img/icons/move-icon.png" alt="Передвигать" class="btn__icon ">
                        {{ getTranslation('addEvent') }}
                    </span>
                </div>
            </div>
        </div>
        <div class="section__body">
            <calendar
                    class="calendar-component"
                    ref="calendarComponent"
                    :defaultView="calendarOptions.defaultView"
                    :header="calendarOptions.header"
                    :plugins="calendarPlugins"
                    :weekends="calendarOptions.calendarWeekends"
                    :events="items"
                    :locale="locale"
                    :all-day-default="calendarOptions.allDayDefault"
                    :event-overlap="calendarOptions.eventOverlap"
                    :droppable="calendarOptions.droppable"
                    :window-resize-delay="calendarOptions.windowResizeDelay"
                    :editable="editable"
                    :display-event-end="calendarOptions.displayEventEnd"
                    :event-time-format="eventTimeFormat"
                    :business-hours="calendarOptions.businessHours===false ? false : businessHours"
                    :event-allow="eventAllow"
                    :now-indicator="true"
                    @eventResize="eventResize"
                    @eventDrop="eventDragged"
                    @drop="dropEvent"
                    :dates-render="datesRender"
                    :slot-duration="'00:10:00'"
                    @eventClick="eventClick"
            />
        </div>
    </section>
</template>

<script>
    import listPlugin from '@fullcalendar/list';
    import interactionPlugin, { Draggable } from '@fullcalendar/interaction';
    import dayGridPlugin from '@fullcalendar/daygrid';
    import timeGridPlugin from '@fullcalendar/timegrid';
    import FullCalendar from '@fullcalendar/vue'
    import ruLocale from '@fullcalendar/core/locales/ru'
    import testingEventsMixin from "../views/admin/events/mixin/testingEvents";
    import moment from 'moment';
    import applicationProfileMixin from "../views/admin/applications/mixins/applicationProfile";
    import officeProfileMixin from "../views/admin/offices/mixins/officeProfile";
    import calendarMixin from "./mixins/Calendar";

    export default {
        name: "CalendarComponent",
        mixins: [testingEventsMixin, applicationProfileMixin, officeProfileMixin, calendarMixin],
        props: {
            active: {
                type: Boolean,
                default: false,
            },
            subjectId: {
                required: true
            },
            subjectType: {
                type: String,
                required: true,
            },
            calendarOptions: {
                type: Object
            },
            testingInterval: {
                default: 10
            },
            eventEdit: {
                type: Boolean,
                default: false,
            },
            filterParams: {
                type: Object
            }
        },
        components: {
            'calendar': FullCalendar
        },

        data() {
            return {
                hideTip: true,
                currentDate: null,
                editable: false,
                locale: ruLocale,
                calendarPlugins: [
                    dayGridPlugin,
                    timeGridPlugin,
                    interactionPlugin,
                    listPlugin
                ],
                eventTimeFormat: {
                    hour: '2-digit',
                    minute: '2-digit',
                    omitZeroMinute: false,
                    meridiem: false
                },
                eventForm: {},
                businessHours: {
                    daysOfWeek: [1, 2, 3, 4, 5, 6, 0],
                    endTime: '18:00',
                    startTime: '09:00'
                },

                draggedEvent: {},
                calendarApi: null,
                dataFetched: false,
            }
        },
        mounted() {
            if ( this.calendarOptions.eventCreate )
                this.setUpDraggable();

            if ( this.calendarOptions.editable )
                this.editable = true;

            this.calendarApi = this.$refs.calendarComponent.getApi();
        },

        created() {

            if ( this.active ) {
                this.checkSubject( this.subjectType );

                if ( this.calendarOptions.eventCreate || this.subjectType === 'application' )
                    this.fetchApplication( this.$route.params.id );
            }


        },
        watch: {
            'subjectId'() {
                if ( this.active )
                    this.checkSubject( this.subjectType )
                        .then( () => {
                            if ( this.calendarOptions.eventCreate && this.subjectType === 'office' )
                                this.fetchApplication( this.$route.params.id ).then( () => {
                                    this.setUpDraggable();
                                } );
                        } );

            },

            'filterParams.filter'() {
                if ( this.active )
                  this.checkSubject( this.subjectType );
            },
            'active'( val ) {
                if ( val )
                    this.checkSubject( this.subjectType );

            }
        },
        methods: {

            datesRender( data ) {



             if (this.active && !this.dataFetched)
               return;

              console.log('datesRender')

                let dateFrom = moment( data.view.activeStart ).format( 'YYYY-MM-DD' );
                let dateTo = moment( data.view.activeEnd ).format( 'YYYY-MM-DD' );

                let params = {
                    dateFrom: dateFrom,
                    dateTo: dateTo,
                    ...this.filterParams
                };


                if ( this.subjectType === 'application' && this.active )
                    this.fetchCalendarEvents( this.subjectId, params );

                if ( this.subjectType === 'office' && this.active )
                    this.fetchOfficeEvents( this.subjectId, true, params );

                if ( this.subjectType === 'all' && this.active ) {
                    this.fetchCalendarEvents( null, params, 'all' );
                }


            },

            eventDragged( eventDropInfo ) {


                let eventItem = eventDropInfo.event;

                console.log('dragged');

                let arr = this.items.filter( item => {
                    return item.id === parseInt( eventItem.id );
                } );

                if ( arr.length < 1 )
                    return this.snotifyError( 'askFrontEnder' );

                this.eventForm.officeId = arr[0].office.id;

                this.updateEvent( eventDropInfo, this.items ).then( () => {
                } );

            },

            updateEvent( eventDropInfo, eventsArray = [] ) {

                if ( !this.hasPermission( 'api.application.profile.editEvent' ) )
                    return this.snotifyError( 'pageForbidden' );

                let eventItem = eventDropInfo.event;

                let max = this.getLastEventTime( moment( eventItem.start ).format( 'YYYY-MM-DD' ), eventsArray, parseInt( eventItem.id ), true );

                this.eventForm = {
                    id: parseInt( eventItem.id ),
                    startTime: moment( eventItem.start ).format( 'YYYY-MM-DD HH:mm' ),
                    endTime: moment( eventItem.end ).format( 'YYYY-MM-DD HH:mm' ),
                    officeId: eventItem.extendedProps.office.id,
                };


                if ( max && eventDropInfo.view.type === 'dayGridMonth' ) {

                    let timingObject = this.checkForTiming( eventItem, this.items );

                    if ( timingObject ) {
                        this.eventForm.endTime = timingObject.endTime;
                        this.eventForm.startTime = timingObject.startTime;
                    }

                }


                return this.saveAppEvent( this.$route.params.id, parseInt( eventItem.id ) )
                           .then( () => {

                               let params = this.getDateParams();

                               if ( this.subjectType === 'office' )
                                   this.fetchOfficeEvents( this.subjectId, true, params );

                               if ( this.subjectType === 'application' )
                                   this.fetchCalendarEvents( this.subjectId, params );

                           } ).catch( () => {
                        eventDropInfo.revert();
                    } ).finally( () => {
                        this.$forceUpdate();
                    } );


            },

            eventResize: function ( eventResizeInfo ) {

                if ( !this.hasPermission( 'api.application.profile.editEvent' ) )
                    return this.snotifyError( 'pageForbidden' );

                let arr = this.items.filter( item => {
                    return item.id === eventResizeInfo.event.extendedProps.eventId;
                } );

                let item = arr[0];

                this.eventForm = {
                    id: item.id,
                    officeId: item.office.id,
                    endTime: moment( item.endTime, 'YYYY-MM-DD HH:mm' ).add( eventResizeInfo.endDelta.milliseconds, 'milliseconds' ).format( 'YYYY-MM-DD HH:mm' ),
                    startTime: item.startTime,
                };


                this.saveAppEvent( this.$route.params.id, item.id )
                    .then( () => {

                        let params = this.getDateParams();

                        if ( this.subjectType === 'office' )
                            this.fetchOfficeEvents( this.subjectId, true, params );

                        if ( this.subjectType === 'application' )
                            this.fetchCalendarEvents( this.subjectId, params );

                    } ).catch( () => {
                    eventResizeInfo.revert();
                } ).finally( () => {
                    this.$forceUpdate();
                } );


            },

            eventClick( eventInfo ) {
                let app = eventInfo.event.extendedProps.application;
                let itemInfo = eventInfo.event.extendedProps;
                let routeData = this.$router.resolve( { name: 'api.application.get', params: { id: app.id }, query: { tab: 'events' } } );

                let statusBadge = '';

                if ( app.status === 'NEW' )
                    statusBadge = '<span class="badge badge--success" >' + this.getTranslation( 'APPLICATION_' + app.status ) + '</span>';
                else if ( app.status === 'REJECTED' )
                    statusBadge = '<span class="badge badge--accent" >' + this.getTranslation( 'APPLICATION_' + app.status ) + '</span>';
                else
                    statusBadge = '<span class="badge" >' + this.getTranslation( 'APPLICATION_' + app.status ) + '</span>';

                let eventStatus;

                if ( itemInfo.eventStatus === 'EVENT_FAILED' )
                    eventStatus = this.getTranslation( 'EVENT_FAILED' );
                else
                    eventStatus = this.getTranslation( 'testing_' + itemInfo.testingStatus );

                let recourseTitle = app.resource.title;

                let depName = '';

                if ( app.resource.type.id === this.RESOURCE_NRK_ID )
                    recourseTitle = app.resource.resourceTitle;

                if ( app.resource.type.id === this.RESOURCE_EKYZMAT_ID )
                {
                  depName = app.resource.department.short ? app.resource.department.short : app.resource.department.title;
                }


                let time = moment( itemInfo.startTime, 'YYYY-MM-DD HH:mm' ).format( 'HH:mm' ) + ' - ' + moment( itemInfo.endTime, 'YYYY-MM-DD HH:mm' ).format( 'HH:mm' );
                let date = moment( itemInfo.startTime, 'YYYY-MM-DD HH:mm' ).format( 'DD.MM.YYYY' );

                let html = `
                <div class="container">
                 <h3 class="section__title text-center mb-3"  > ${ this.getTranslation( 'application' ) }</h3>
                <div class="row" >
                    <div class="col-4 text-left"><strong>${ this.getTranslation( 'title' ) }: </strong></div>
                    <div class="col-8 text-left" > <a href="${ routeData.href }"> ${ app.title }</a></div>
                </div>
                <div class="row" >
                    <div class="col-4 text-left"><strong>${ this.getTranslation( 'status' ) }: </strong></div>
                    <div class="col-8 text-left" >${ statusBadge }</div>
                </div>
                <div class="row">
                    <div class="col-4 text-left"> <strong>${ this.getTranslation( 'position' ) }: </strong></div>
                    <div class="col-8 text-left">  ${ recourseTitle }</div>
                </div>
                <div class="row">
                    <div class="col-4 text-left"> <strong>${ this.getTranslation( 'department' ) }: </strong></div>
                    <div class="col-8 text-left">  ${ depName }</div>
                </div>
                <div class="row">
                    <div class="col-4 text-left"> <strong>${ this.getTranslation( 'state' ) }: </strong></div>
                    <div class="col-8 text-left">  ${ itemInfo.stateText }</div>
                </div>
                 <h3 class="section__title text-center mb-3 mt-4" > ${ this.getTranslation( 'event' ) } </h3>
                  <div class="row">
                    <div class="col-4 text-left"><strong>${ this.getTranslation( 'office' ) }: </strong></div>
                    <div class="col-8 text-left"><a href="/admin/offices/${ itemInfo.office.id }"> ${ itemInfo.office.title }</a></div>
                 </div>
                 <div class="row">
                    <div class="col-4 text-left"><strong>${ this.getTranslation( 'dateAndTime' ) }: </strong></div>
                    <div class="col-8 text-left"> ${ time }, ${ date }</div>
                 </div>
                 <div class="row">
                    <div class="col-4 text-left"><strong>${ this.getTranslation( 'candidates' ) }: </strong></div>
                    <div class="col-8 text-left"> <span class="counter-candidate">${ itemInfo.candidateCount }</span></div>
                 </div>
                 <div class="row mt-1">
                    <div class="col-4 text-left"><strong>${ this.getTranslation( 'availableCount' ) }: </strong></div>
                    <div class="col-8 text-left align-bottom"> <span class="counter-available">${ itemInfo.availableCount }</span></div>
                 </div>
                 <div class="row">
                    <div class="col-4 text-left"><strong>${ this.getTranslation( 'status' ) }: </strong></div>
                    <div class="col-8 text-left">${ eventStatus }</div>
                 </div>
                 <div class="row">
                    <div class="col-12 text-center"><a href="/admin/events/${ itemInfo.eventId }">${ this.getTranslation( 'viewPage' ) }</a></div>
                 </div>
                </div> `;

                Swal.fire( {
                    heightAuto: true,
                    html: html,
                } )
            },

            eventAllow( dropInfo, draggedEvent ) {


                let end = dropInfo.end;
                let today = moment().toDate();

                let app = draggedEvent.extendedProps.application;

                //don't allow past time
                if ( moment( today ).isAfter( end ) )
                    return false;

                if ( draggedEvent.extendedProps.isActive )
                    return false;


                //don't allow if app status is not new
                if ( draggedEvent.extendedProps.application ) {

                    if ( draggedEvent.extendedProps.application.status !== 'NEW' || draggedEvent.extendedProps.application.id !== parseInt( this.$route.params.id ) )
                        return false;

                }


                let maxDate = this.getMaxDate( this.items );

                //allow after max date
                if ( moment( dropInfo.start ).isAfter( maxDate ) && app && app.id === parseInt( this.$route.params.id ) ) {
                    return true;
                }

                //allow the same date
                if ( moment( dropInfo.start ).isSame( draggedEvent.start ) && app && app.id === parseInt( this.$route.params.id ) )
                    return true;

                return true;

            },

            checkSubject( subjectType ) {

              console.log('checkSubject')

                let params = this.getDateParams();

                switch ( subjectType ) {
                    case 'office':

                        return this.fetchOfficeEvents( this.subjectId, true, { ...params, ...this.filterParams } ).then( () => {
                            this.dataFetched = true;
                        } );


                    case 'application':
                        return this.fetchCalendarEvents( this.subjectId, params ).then( () => {
                            this.dataFetched = true;
                        } );

                    case 'all':
                        return this.fetchCalendarEvents( null, { ...params, ...this.filterParams }, 'all' ).then( () => {
                            this.dataFetched = true;
                        } );

                }
            },

            dropEvent( data ) {
                console.log('dropped');
                this.createEvent( data, this.items );
            },

            createEvent( dropEvent, eventsArray = [] ) {

                if ( !this.hasPermission( 'api.application.profile.createEvent' ) )
                    return this.snotifyError( 'pageForbidden' );

                let date = dropEvent.date;

                let max = this.getLastEventTime( date, eventsArray );


                let title = this.getTranslation( 'newTestingEvent' );

                if ( this.application.resource.resourceType.id === this.RESOURCE_EKYZMAT_ID || this.application.resource.resourceType.id === this.RESOURCE_LOCAL_POSITIONS_ID )
                    title = this.application.resource.positionName;
                else
                    title = this.application.resource.title;

                let totalDuration = 0;
                let period = 'minutes';

                if ( this.application.testingStructure )
                    totalDuration = this.application.testingStructure.duration + 5;
                else {
                    totalDuration = 1;
                    period = 'hours';
                }

                let startISO = null;
                let endISO = null;

                let startTime = null;
                let endTime = null;

                if ( max && max.available ) {
                    startISO = moment( max.time ).format();
                    startTime = moment( max.time ).format( 'YYYY-MM-DD HH:mm' );

                    endTime = moment( startTime, 'YYYY-MM-DD HH:mm' ).add( totalDuration, period ).format( 'YYYY-MM-DD HH:mm' );
                    endISO = moment( startTime, 'YYYY-MM-DD HH:mm' ).add( totalDuration, period ).format();
                }

                else if ( max ) {
                    startISO = moment( max ).add( this.testingInterval, 'minutes' ).format();
                    startTime = moment( max ).add( this.testingInterval, 'minutes' ).format( 'YYYY-MM-DD HH:mm' );

                    endTime = moment( startTime, 'YYYY-MM-DD HH:mm' ).add( totalDuration, period ).format( 'YYYY-MM-DD HH:mm' );
                    endISO = moment( startTime, 'YYYY-MM-DD HH:mm' ).add( totalDuration, period ).format();
                }
                else {
                    startISO = moment( date, 'YYYY-MM-DD' ).add( 9, 'hours' ).format();
                    startTime = moment( date, 'YYYY-MM-DD' ).add( 9, 'hours' ).format( 'YYYY-MM-DD HH:mm' );

                    endTime = moment( startTime, 'YYYY-MM-DD HH:mm' ).add( totalDuration, period ).format( 'YYYY-MM-DD HH:mm' );
                    endISO = moment( startTime, 'YYYY-MM-DD HH:mm' ).add( totalDuration, period ).format();
                }


                this.eventForm = { officeId: this.subjectId, startTime: startTime, endTime: endTime, title: title, end: endISO, start: startISO };

                this.saveAppEvent( this.$route.params.id, null )
                    .then( () => {

                        let params = this.getDateParams();


                        if ( this.subjectType === 'office' ) {
                            this.fetchApplication( this.$route.params.id );
                            this.fetchOfficeEvents( this.subjectId, true, params );
                        }

                        if ( this.subjectType === 'application' )
                            this.fetchCalendarEvents( this.subjectId, params );
                    } )
                    .catch( () => {

                    } ).finally( () => {
                    this.$forceUpdate();
                } );

                return true;
            },

        }
    }
</script>

<style scoped>
    @import '~@fullcalendar/core/main.css';
    @import '~@fullcalendar/daygrid/main.css';
    @import "../assets/css/customDaygrid.css";
    @import '~@fullcalendar/timegrid/main.css';
    @import '~@fullcalendar/list/main.css';

    .section {
        height: 100% !important;
    }


</style>
